import React from 'react';
import './privacyPolicy.css';
import Footer from '../components/footer';
import { Helmet } from 'react-helmet';

export default function PrivacyPolicy() {
  return (
   <>

<Helmet>
    <title>Privacy Policy | Stamens Software - Your Privacy Matters to Us</title>
    <meta name="description" content="Read the privacy policy of Stamens Software to understand how we collect, use, and protect your personal information. Your privacy is our priority, and we are committed to ensuring transparency and security." />
    <meta name="keywords" content="Privacy Policy, Stamens Software, Data Protection, Privacy, Personal Information, User Privacy, IT Company Privacy Policy, Data Security" />
</Helmet>


<section className="custom-banner">
            <div className="container">
                <h1 className="banner-head text-center">
                    <span>Stamens Software</span>
                    Privacy Policy
                </h1>
            </div>
        </section>

        <section className="privacy-details">
    <div className="container">
        <div className="details-info">
            <h2 className="h2">Our Contact Details</h2>
            <p>Name: Stamens Software Pvt Ltd</p>
            <p>Address: B-33, 2nd Floor, Sector 6, Noida, Uttar Pradesh, India - 201301</p>
            <p>Telephone: +91 120 3500 847, +91 120 3500 848</p>
            <p>Email: contact@stamenssoftware.com</p>

            <h3 className="h2">This website is owned and operated by Stamens Software Pvt Ltd.</h3>
            <p>We encourage all users to read this Privacy Policy before visiting our website. At Stamens Software, we understand the importance of privacy for our visitors and customers who use our website, www.stamenssoftware.com. This policy demonstrates our strong commitment to safeguarding user privacy. We respect the privacy of individuals who use our software applications and services offered on the Stamens Software website.</p>

            <p>We do not collect personal information from individuals visiting our website unless they provide it voluntarily. There is no requirement for users to register or provide personal details to access or view the website. We take all necessary steps to protect our users' data from any loss, misuse, or unauthorized changes.</p>

            <p>During the purchase process, we may request certain information which is collected solely for specified purposes. Stamens Software does not sell, rent, or share any of your personal data with third parties. We only use the information you provide to send updates related to our software solutions, services, and other important notices. Stamens Software never sells or distributes your information to external parties.</p>

            <h4 className="h2">Information collected from our customers is used for the following purposes:</h4>
            <div className="row justify-content-center gy-4 mb-4">
                <div className="col-md-4">
                    <div className="part">
                        <h5>Technical Support</h5>
                        <p>We may use your email address to respond to your inquiries submitted to our Technical Support section. Our support team will use your email ID to reply to your questions and provide assistance.</p>
                    </div>
                </div>
                <div className="col-md-4">
                    <div className="part">
                        <h5>Email Notifications</h5>
                        <p>If you opt in to our newsletter, you will receive email updates about recent changes on our website, new software releases, promotional offers, and special discounts. You can easily unsubscribe from these emails by following the instructions in every email message.</p>
                    </div>
                </div>
                <div className="col-md-4">
                    <div className="part">
                        <h5>Security</h5>
                        <p>Stamens Software follows the best practices to safeguard your information during online transactions and protect your credit card details. However, Stamens Software is not liable for any security breaches or data loss.</p>
                    </div>
                </div>
            </div>

            <h4 className="h2">What is the scope of this notice?</h4>
            <p>This Privacy Notice explains how we collect, use, share, and protect your personal information (“Information”). This information will be used in accordance with the permissions granted by you and in compliance with the Indian data protection laws, including the Information Technology Act, 2000, and applicable rules under it. We also aim to comply with other relevant national and international data protection regulations, where applicable. If we make any updates to this policy, we will post the changes on our website. We encourage you to read and understand the policy in full. It should also be read in conjunction with our General Terms and Conditions and Cookie Notice.</p>

            <p>Stamens Software does not accept responsibility or liability for the content, privacy policies, or practices of external websites linked from our website. We recommend that you review the terms and privacy policies of any third-party websites before providing your information to them.</p>

            <p>This notice applies to the website or portal on which it is posted and also to interactions through social media channels such as Facebook™, Twitter™, LinkedIn™, and YouTube™.</p>

        </div>
    </div>
</section>


   <Footer />
   </>
  )
}
